import { NexusPermission } from './nexus-permissions.js';

/** Single super-admin role for SmartTeams + Nexus (shared Mongo `roles`). */
export const NEXUS_ADMIN_ROLE_NAME = 'NSC Nexus Admin' as const;

/** Permissions listed on Nexus “Roles” matrix / create / tester (Nexus-only strings). */
export function getNexusRoleManagementPermissions(): string[] {
  return [...new Set(Object.values(NexusPermission) as string[])];
}
